import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import {CurrencyModel} from '../../../../../shared/models/CurrencyModel';
import {FundReportReqRes} from '../../../../../shared/models/FundReportReqRes.model';
import {UtilsService} from '../../../../../services/utils.service';
import MetaFileLink, {MediaType} from '../../../../../models/metaFileLink.model';
import {InfoDialogComponent, InfoDialogModel} from '../../../../shared/info-dialog/info-dialog.component';
import {ReportFAQReqRes} from '../../../../../shared/models/reportFAQReqRes.model';
import {ReportFaqsDialogComponent} from '../../../../shared/holdings/report-faqs-dialog/report-faqs-dialog.component';
import {ReportFileReqRes} from '../../../../../shared/models/ReportFileReqRes.model';
import ReportFileType from '../../../../../shared/enums/ReportFileType.enum';
import HoldingDiscriminator from '../../../../../shared/enums/HoldingDiscriminator.enum';
import {AssetReportReqRes} from '../../../../../shared/models/AssetReportReqRes.model';
import {HoldingReportReqRes} from '../../../../../shared/models/HoldingReportReqRes';

@Component({
  selector: 'terra-holding-report',
  templateUrl: './holding-report.component.html',
  styleUrls: ['./holding-report.component.scss', '../../../../styles/holding/holding-page-shared.scss']
})
export class HoldingReportComponent implements OnInit, OnChanges {
  @Input() isExample = false;
  @Input() holdingCurrency: CurrencyModel;
  @Input() report: FundReportReqRes | AssetReportReqRes;
  @Input() holdingDiscriminator: HoldingDiscriminator;
  @Input() isGpPreviewMode = false;

  reportAsFundReport: FundReportReqRes;
  reportAsAssetReport: AssetReportReqRes;

  // enums
  HoldingDiscriminator = HoldingDiscriminator;

  constructor(
    private matDialog: MatDialog,
    private utilsService: UtilsService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.report) {
      this.reportAsFundReport = this.report as FundReportReqRes;
      this.reportAsAssetReport = this.report as AssetReportReqRes;
    }
  }

  getReportDocumentFileUrl(report: HoldingReportReqRes) {
    const reportFile = this.getReportDocumentFile(report);
    if (!reportFile) {
      return null;
    }
    return reportFile.metaFileLink.url;
  }

  getImagesVideoAudioFiles(report: HoldingReportReqRes): MetaFileLink[] {
    if (!report || !report.attachments) {
      return null;
    } else {
      const allowedTypes = [MediaType.Image, MediaType.Video, MediaType.Audio];
      return this.getMediaFileMetaFileLinks(report).filter(metaFile => allowedTypes.includes(MetaFileLink.GetMediaType(metaFile)));
    }
  }


  getMediaFilesNotImageVideo(report: HoldingReportReqRes): MetaFileLink[] {
    if (!report || !report.attachments) {
      return null;
    } else {
      const notAllowedTypes = [MediaType.Image, MediaType.Video, MediaType.Audio];
      return this.getMediaFileMetaFileLinks(report).filter(metaFile => !notAllowedTypes.includes(MetaFileLink.GetMediaType(metaFile)));
    }
  }

  showSimpleInfoDialog(title: string, content: string) {
    const dialogConfig = new MatDialogConfig<InfoDialogModel>();
    dialogConfig.disableClose = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '100vw';
    dialogConfig.maxWidth = '600px';
    dialogConfig.height = '100vh';
    dialogConfig.maxHeight = '800px';
    dialogConfig.panelClass = this.isGpPreviewMode ? 'info-dialog-no-shadow' : 'info-dialog';

    const data = new InfoDialogModel();
    data.title = title;
    data.content = content;
    dialogConfig.data = data;
    this.matDialog.open(InfoDialogComponent, dialogConfig);
  }


  showFaqsDialog(faqs: ReportFAQReqRes[]) {
    const dialogConfig = new MatDialogConfig<ReportFAQReqRes[]>();
    dialogConfig.disableClose = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '100vw';
    dialogConfig.maxWidth = '600px';
    dialogConfig.height = '100vh';
    dialogConfig.maxHeight = '800px';
    dialogConfig.panelClass = this.isGpPreviewMode ? 'info-dialog-no-shadow' : 'info-dialog';
    dialogConfig.data = faqs;
    this.matDialog.open(ReportFaqsDialogComponent, dialogConfig);
  }

  private getReportDocumentFile(report: HoldingReportReqRes): ReportFileReqRes {
    if (!report || !report.attachments) {
      return null;
    } else {
      return report.attachments.find(a => a.fileType === ReportFileType.ReportDocument);
    }
  }

  private getMediaFileMetaFileLinks(report: HoldingReportReqRes): MetaFileLink[] {
    if (!report || !report.attachments) {
      return null;
    } else {
      try {
        return report.attachments.filter(a => a.fileType === ReportFileType.ReportMedia || a.fileType === ReportFileType.ReportMediaRentManager).map(a => a.metaFileLink);
      } catch {
        return null;
      }
    }
  }

}
